import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { queryKeys } from './api/queries';
import { ToastProvider } from './components/Toast';
import { ApiError } from './lib/api';
import { router } from './router';
import './styles.css';

// If the admin session expires, any 401 sends the user back to the login screen.
const onError = (err: unknown) => {
  if (err instanceof ApiError && err.status === 401 && !location.pathname.startsWith('/f/')) {
    queryClient.setQueryData(queryKeys.me, null);
  }
};

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError }),
  mutationCache: new MutationCache({ onError }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (count, err) => !(err instanceof ApiError && err.status < 500) && count < 2,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
